"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Button = _interopRequireDefault(require("../Button"));
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));
var _fadeInAndOut = _interopRequireDefault(require("../../styles/animations/fadeInAndOut"));
var _userflow = require("../../constants/userflow");
var _excluded = ["date", "price", "pricePerNight", "active", "priceOnDemand", "mobile", "showBackground", "skeleton", "dataIndex"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ACTIVE_BACKGROUND_TRIANGLE_HEIGHT = 10;
var WHITE_TRIANGLE_HEIGHT = 13;
var BUTTON_WIDTH = 126;
var BUTTON_WIDTH_MOBILE = 106;
var SKELETON_LINE = '___________';
var SearcherDateCarouselItem = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var date = _ref.date,
    price = _ref.price,
    pricePerNight = _ref.pricePerNight,
    active = _ref.active,
    priceOnDemand = _ref.priceOnDemand,
    mobile = _ref.mobile,
    showBackground = _ref.showBackground,
    skeleton = _ref.skeleton,
    dataIndex = _ref.dataIndex,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  var showActiveBackground = showBackground && active && !mobile;
  var disabled = skeleton || !mobile && (active || !price && !priceOnDemand);
  return /*#__PURE__*/_react["default"].createElement(StyledSearcherDateCarouselItem, (0, _extends2["default"])({}, props, {
    showActiveBackground: showActiveBackground,
    disabled: disabled,
    mobile: mobile
  }), /*#__PURE__*/_react["default"].createElement(StyledDate, {
    active: active,
    mobile: mobile
  }, date), /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    active: active,
    mobile: mobile,
    skeletonAnimation: skeleton,
    style: {
      animationDelay: "".concat(-(dataIndex * _userflow.SKELETON_ANIMATION_DELAY), "ms")
    }
  }, skeleton ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, SKELETON_LINE), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, SKELETON_LINE)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, priceOnDemand ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
    mobile: mobile
  }, mobile && active ? t('hotel.carousel.getPriceMobileActive') : t('hotel.carousel.getPrice')) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, price ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.carousel.startPrice')), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: price,
    currencyCode: code
  }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.carousel.startPrice')), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: pricePerNight,
    currencyCode: code
  }), /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.carousel.night'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.carousel.noOffers', {
    context: 'package'
  })))))), showActiveBackground && /*#__PURE__*/_react["default"].createElement(StyledTriangleWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledActiveBackGroundTriangle, {
    width: BUTTON_WIDTH
  }), /*#__PURE__*/_react["default"].createElement(StyledWhiteTriangle, {
    width: BUTTON_WIDTH + 40
  })));
});
SearcherDateCarouselItem.displayName = 'SearcherDateCarouselItem';
SearcherDateCarouselItem.propTypes = {
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  date: _propTypes["default"].string.isRequired,
  price: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  pricePerNight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClick: _propTypes["default"].func,
  priceOnDemand: _propTypes["default"].bool,
  mobile: _propTypes["default"].bool,
  showBackground: _propTypes["default"].bool,
  skeleton: _propTypes["default"].bool,
  dataIndex: _propTypes["default"].number
};
SearcherDateCarouselItem.defaultProps = {
  active: false,
  className: '',
  price: '',
  pricePerNight: '',
  onClick: null,
  priceOnDemand: false,
  mobile: false,
  showBackground: false,
  skeleton: false,
  dataIndex: 0
};
var StyledSearcherDateCarouselItem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "SearcherDateCarouselItem__StyledSearcherDateCarouselItem",
  componentId: "sc-6nu2s1-0"
})(["outline:0;width:", "px;text-align:center;position:relative;padding:12px 0;margin:0;", " *{position:relative;z-index:1;}"], function (props) {
  return props.mobile ? BUTTON_WIDTH_MOBILE : BUTTON_WIDTH;
}, function (props) {
  return props.showActiveBackground && (0, _styledComponents.css)(["padding-bottom:", "px;::before{content:'';position:absolute;left:0;top:0;right:0;bottom:", "px;z-index:0;background:var(--background);border-radius:var(--border-radius);}"], ACTIVE_BACKGROUND_TRIANGLE_HEIGHT + WHITE_TRIANGLE_HEIGHT + 10, ACTIVE_BACKGROUND_TRIANGLE_HEIGHT + WHITE_TRIANGLE_HEIGHT);
});
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDateCarouselItem__StyledContainer",
  componentId: "sc-6nu2s1-1"
})(["white-space:pre-line;", " ", ""], function (_ref2) {
  var mobile = _ref2.mobile,
    active = _ref2.active;
  return (0, _styledComponents.css)(["", " ", ""], mobile ? (0, _styledComponents.css)(["font-size:12px;line-height:14px;"]) : (0, _styledComponents.css)(["font-size:14px;line-height:16px;height:34px;"]), active ? (0, _styledComponents.css)(["color:var(--black);"]) : (0, _styledComponents.css)(["color:var(--grey1);"]));
}, function (_ref3) {
  var skeletonAnimation = _ref3.skeletonAnimation;
  return skeletonAnimation && (0, _styledComponents.css)(["animation:", " ", "ms ease-in-out infinite;"], _fadeInAndOut["default"], _userflow.SKELETON_ANIMATION_DURATION);
});
var StyledDate = _styledComponents["default"].span.withConfig({
  displayName: "SearcherDateCarouselItem__StyledDate",
  componentId: "sc-6nu2s1-2"
})(["font-style:normal;font-weight:500;", ""], function (_ref4) {
  var active = _ref4.active,
    mobile = _ref4.mobile;
  return (0, _styledComponents.css)(["", " ", ""], mobile ? (0, _styledComponents.css)(["font-size:14px;line-height:16px;"]) : (0, _styledComponents.css)(["font-size:18px;line-height:22px;"]), active ? (0, _styledComponents.css)(["color:var(--black);"]) : (0, _styledComponents.css)(["color:var(--grey1);"]));
});
var StyledButton = _styledComponents["default"].span.withConfig({
  displayName: "SearcherDateCarouselItem__StyledButton",
  componentId: "sc-6nu2s1-3"
})(["color:var(--grey1);", ""], function (_ref5) {
  var mobile = _ref5.mobile;
  return (0, _styledComponents.css)(["", ""], mobile ? (0, _styledComponents.css)(["font-size:12px;line-height:14px;"]) : (0, _styledComponents.css)(["font-size:14px;line-height:16px;"]));
});
var StyledTriangleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDateCarouselItem__StyledTriangleWrapper",
  componentId: "sc-6nu2s1-4"
})(["position:absolute;bottom:0;display:flex;flex-direction:column;left:0;right:0;"]);
var StyledTriangle = _styledComponents["default"].i.withConfig({
  displayName: "SearcherDateCarouselItem__StyledTriangle",
  componentId: "sc-6nu2s1-5"
})(["position:relative;width:0;height:0;z-index:1;"]);
var StyledActiveBackGroundTriangle = (0, _styledComponents["default"])(StyledTriangle).withConfig({
  displayName: "SearcherDateCarouselItem__StyledActiveBackGroundTriangle",
  componentId: "sc-6nu2s1-6"
})(["left:5px;border-top:", "px solid var(--background);border-left:", "px solid var(--white);border-right:", "px solid var(--white);z-index:2;"], ACTIVE_BACKGROUND_TRIANGLE_HEIGHT, (BUTTON_WIDTH - ACTIVE_BACKGROUND_TRIANGLE_HEIGHT) / 2, (BUTTON_WIDTH - ACTIVE_BACKGROUND_TRIANGLE_HEIGHT) / 2);
var StyledWhiteTriangle = (0, _styledComponents["default"])(StyledTriangle).withConfig({
  displayName: "SearcherDateCarouselItem__StyledWhiteTriangle",
  componentId: "sc-6nu2s1-7"
})(["bottom:1px;left:-12px;border-top:", "px solid var(--white);border-left:", "px solid transparent;border-right:", "px solid transparent;"], WHITE_TRIANGLE_HEIGHT, (BUTTON_WIDTH + 40 - WHITE_TRIANGLE_HEIGHT) / 2, (BUTTON_WIDTH + 40 - WHITE_TRIANGLE_HEIGHT) / 2);
SearcherDateCarouselItem.BUTTON_WIDTH = BUTTON_WIDTH;
SearcherDateCarouselItem.BUTTON_WIDTH_MOBILE = BUTTON_WIDTH_MOBILE;
SearcherDateCarouselItem.StyledDate = StyledDate;
SearcherDateCarouselItem.StyledContainer = StyledContainer;
SearcherDateCarouselItem.StyledButton = StyledButton;
var _default = exports["default"] = SearcherDateCarouselItem;